/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const cloudinaryImageDirective = require('./cloudinaryImageDirective');

/**
 * Utility module for working with images within the Enervee applications,
 * specifically with cloudinary.
 */
const imageUtilsModule = angular
    .module('enervee_utils.image_utils', [
        'cloudinary',
    ])
    .directive('cloudinaryImage', cloudinaryImageDirective);

module.exports = imageUtilsModule;